/* Pat Kay — live search suggestions in the search takeover (predictive search API).
   Typing swaps the quick links for product matches; Enter submits to /search. */

(function () {
  var input = document.getElementById('u-search-input');
  var results = document.getElementById('u-search-results');
  if (!input || !results) return;

  var defaultHTML = results.innerHTML;
  var timer = null;
  var seq = 0;

  function restore() {
    results.classList.remove('is-results');
    results.innerHTML = defaultHTML;
  }

  function render(products, q) {
    results.classList.add('is-results');
    if (!products.length) {
      results.innerHTML = '<span class="u-empty">Nothing found for “' + q.replace(/</g, '&lt;') + '”</span>';
      return;
    }
    results.innerHTML = products.map(function (p) {
      var price = p.price ? '<span class="price">$' + p.price.replace(/\.00$/, '') + '</span>' : '';
      return '<a class="u-result" href="' + p.url + '">' + p.title + price + '</a>';
    }).join('');
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { restore(); return; }
    timer = setTimeout(function () {
      var mySeq = ++seq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (mySeq !== seq) return; // stale response
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () {});
    }, 220);
  });
})();
